export const CHECK_DATA_REQUEST = "CHECK_DATA_REQUEST"
export const CHECK_DATA_SUCCESS = "CHECK_DATA_SUCCESS"
export const CHECK_DATA_FAILED = "CHECK_DATA_FAILED"
